import ArticleLinkGroq from './ArticleLinkGroq';

export default `{
  header,
  "articles": articles[]->${ArticleLinkGroq}
}`;
